import http from "../../utils/http";

export const getTaxProdList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing/taxProd/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteTaxProdList = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/management/billing/taxProd`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addTaxProd = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing/taxProd`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editTaxProd = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/management/billing/taxProd/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBillings = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addBilling = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editBilling = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/management/billing/${idx}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const paymentList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing/payment/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const paymentChangeStatus = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/management/billing/payment/status`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const allCanceledBilling = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/management/billing/canceled`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};